<script setup lang="ts">
/**
 * design-system.md -> Components -> Field. 44px control, radius 8, `line-strong` border. Focus is
 * the ink border + 3px lime halo (main.css). URLs and slugs use `mono` (13px).
 *
 * `id`, `aria-describedby` etc. fall through to the root <input> — pass them from Field's scoped
 * slot (see Field.vue) or set them directly when used standalone.
 */
withDefaults(
  defineProps<{
    modelValue: string;
    type?: string;
    mono?: boolean;
    invalid?: boolean;
    disabled?: boolean;
    placeholder?: string;
  }>(),
  { type: 'text', mono: false, invalid: false, disabled: false }
);

defineEmits<{ 'update:modelValue': [value: string] }>();
</script>

<template>
  <input
    :type="type"
    :value="modelValue"
    :disabled="disabled"
    :placeholder="placeholder"
    :aria-invalid="invalid || undefined"
    class="h-11 w-full rounded-control border bg-surface px-3.5 text-ink placeholder:text-icon-muted disabled:cursor-not-allowed disabled:border-line disabled:bg-wash disabled:text-ink-3"
    :class="[mono ? 'type-code text-[13px]' : 'type-body text-sm leading-none', invalid ? 'border-danger-fg' : 'border-line-strong']"
    @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
  />
</template>
